(function ($, Drupal, once) {
  'use strict';

  const ptb_custom_settings = drupalSettings.ptb_custom_settings;

  Drupal.behaviors.weaver_tailwind_takeovers = {

    checkScroll: function() {
      // add class once header including buttons are scrolled out of view
      this.positionSideButtons(window.scrollY);
      window.addEventListener('scroll', (e) => {
        this.positionSideButtons(window.scrollY);
      });
    },

    closeAllTakeovers: function() {
      let sideButtons = this.getSideButtons();

      sideButtons.forEach((sideButton) => {
        let takeoverTargetId = sideButton.dataset.tweTarget.replace('#', '');
        this.closeTakeover(takeoverTargetId);
        this.closeSidebutt(sideButton);
      });
    },

    closeSidebutt: function(button) {
      button.dataset.ptbToggle = 'closed';
    },

    closeTakeover: function(takeoverId) {
      const takeoverElement = document.getElementById(takeoverId);

      if (takeoverElement == null) {
        return;
      }

      const takeover = twe.Offcanvas.getOrCreateInstance(takeoverElement);
      takeover.hide();
    },

    focusSearchInput: function() {
      const searchInput = document.getElementById('ptb-search-input');
      if (searchInput == null) {
        return;
      }

      setTimeout(() => {
        searchInput.focus();
      }, 200);
    },

    getSidebuttonFromClose: function(trigger) {
      const sidebutt = document.getElementById('ptb-sidebutt');
      const target = trigger.dataset.tweTarget;
      if (sidebutt == null || target == null) {
        return trigger;
      }

      let sidebutton = sidebutt.querySelector('[data-twe-target="' + target + '"]');

      return sidebutton;
    },

    getSideButtons: function() {
      let sideButtons = document.querySelectorAll('#ptb-sidebutt > button, .ptb-offcanvas-close');
      return sideButtons;
    },

    initializeLinkClicks: function() {
      const takeovers = document.querySelectorAll('.ptb-takeover');
      if (takeovers.length <= 0) {
        return;
      }

      takeovers.forEach((takeover) => {
        let links = takeover.querySelectorAll('a');
        if (links.length > 0) {

          links.forEach((link) => {
            link.addEventListener('click', () => {
              this.takeoverLinkClick(link);
            });
          });
        }
      });
    },

    initializeKeyboardShortcuts: function() {
      document.addEventListener('keydown', (e) => {
        const sideButtons = this.getSideButtons();

        if (e.code == 'Escape') {
          this.closeAllTakeovers();
        }

        if (sideButtons.length <= 0) {
          return;
        }

        let i;
        for (i=49; i<=52; i++) {
          if (e.keyCode == i && (e.metaKey || e.ctrlKey)) {
            this.closeAllTakeovers();
            let buttonId = i - 49; // e.g., if i=49, buttonId = 0
            let takeoverTargetId = sideButtons[buttonId].dataset.tweTarget.replace('#', '');
            let takeoverTarget = document.getElementById(takeoverTargetId);
            let sideButton = document.querySelector('#ptb-sidebutt button[data-twe-target="#' + takeoverTargetId + '"]');
            this.openSidebutt(sideButton, sideButtons);
            this.openTakeover(takeoverTargetId);
          }
        }

      });
    },

    // initializes links on a page that will toggle a takeover -- e.g., #nav-1
    initializeNavHashLinks: function() {
      const hashLinks = document.querySelectorAll('a');
      if (hashLinks.length <= 0) {
        return;
      }

      hashLinks.forEach((link) => {
        let href = link.getAttribute('href');
        const linkPattern = /#nav-(\d+)/;

        if (href == null || !linkPattern.test(href)) {
          return;
        }

        const match = href.match(linkPattern);
        const navId = match[1];

        link.addEventListener('click', (e) => {
          let sideButtId = 'ptb-sidebutt-' + navId;
          let sideButtons = this.getSideButtons();

          if (sideButtons == null) {
            return;
          }

          let sideButton = document.querySelector('#ptb-sidebutt button[data-twe-target="#' + sideButtId + '"]');
          
          if(sideButton == null) {
            return;
          }

          this.toggleTakeover(sideButtId);
          this.toggleSidebutt(sideButton, sideButtons);
        });
      });
    },

    initializeOffcanvasEvents: function() {
      const offcanvases = document.querySelectorAll('[data-twe-offcanvas-init]');

      if (offcanvases <= 0) {
        return;
      }

      offcanvases.forEach((offcanvas) => {
        offcanvas.addEventListener('show.twe.offcanvas', (e) => {
          // allows for styling elements on page via data-ptb-offcanvas-active state on <body>
          let offcanvasId = offcanvas.getAttribute('id');
          document.body.dataset.ptbOffcanvasActive = offcanvasId;

          if (offcanvasId == 'ptb-sidebutt-3') {
            //move focus to search input
            this.focusSearchInput();
          }

          // closes other offcanvas elements
          this.closeAllTakeovers();
        });
        offcanvas.addEventListener('hide.twe.offcanvas', (e) => {
          document.body.dataset.ptbOffcanvasActive = null;
        });
      });
    },

    initializeTakeoverSearchForm: function() {

      const searchForm = document.getElementById('ptb-takeover-search-form');

      if (searchForm == null) {
        return;
      }

      let searchButton = searchForm.querySelector('button[name="ptb_search_submit"]');
      let applicationSearchButton = searchForm.querySelector('button[name="ptb_applications_search_submit"]');
      let searchInput = searchForm.querySelector('input[name="ptb_search_input"]');

      if ((searchButton == null && applicationSearchButton == null) || searchInput == null) {
        return;
      }

      if (searchButton != null) {
        searchButton.addEventListener('click', (e) => {
          e.preventDefault();
          let searchQuery = searchInput.value;
          if (searchQuery == '') {
            return;
          }
          this.searchWebsite(searchQuery);
        });
      }

      if (applicationSearchButton != null) {
        applicationSearchButton.addEventListener('click', (e) => {
          e.preventDefault();
          let searchQuery = searchInput.value;
          if (searchQuery == '') {
            return;
          }
          this.searchApplications(searchQuery);
        });
      }

      // launch search if Enter pressed while in Search input
      document.addEventListener('keydown', (e) => {
        if ((e.code == 'Enter' || e.code == 'NumpadEnter') && (e.target == searchInput || e.target == searchButton)) {
          let searchQuery = searchInput.value;
          this.searchWebsite(searchQuery);
        }
      });
    },

    initializeToggleSidebutt: function() {
      let sideButtons = this.getSideButtons();
      if (sideButtons.length <= 0) {
        return;
      }

      sideButtons.forEach(sideButton => {
        sideButton.addEventListener('click', (e) => {

          // this is kinda hacky but needed to make close buttons also trigger the icon change
          let trigger = e.target.closest('button');
          if (trigger.classList.contains('ptb-offcanvas-close')) {
            trigger = this.getSidebuttonFromClose(trigger);
          }
          this.toggleSidebutt(trigger, sideButtons);
          // let target = sideButton.dataset.tweTarget.replace('#', '');
        });
      });
    },

    openSidebutt: function(button) {
      button.dataset.ptbToggle = 'open';
    },

    openTakeover: function(takeoverId) {
      const takeoverElement = document.getElementById(takeoverId);

      if (takeoverElement == null) {
        return;
      }

      const takeover = twe.Offcanvas.getOrCreateInstance(takeoverElement);
      takeover.show();
    },

    positionSideButtons: function(y) {
      let header = document.getElementById('masthead');
      if (header == null) {
        return;
      }
      let headerRect = header.getBoundingClientRect();

      if (window.screen.width < 1200) {

        if (y > (headerRect.height + 100)) {
          document.body.classList.add('ptb-sidebutt-fixed');
        } else {
          document.body.classList.remove('ptb-sidebutt-fixed');
        }

      } else {
        document.body.classList.remove('ptb-sidebutt-fixed');
      }
    },

    searchApplications: function(searchQuery) {
      let searchUrl = ptb_custom_settings.all.applications_url;
      window.location.href = searchUrl + '?search=' + searchQuery;
    },

    searchWebsite: function(searchQuery) {
      let searchUrl = ptb_custom_settings.all.search_url;
      window.location.href = searchUrl + '?search=' + searchQuery;
    },

    takeoverLinkClick: function(link) {
      // if this is anchor link to same page, close takeovers
      let href = link.getAttribute('href');
      if (!href.includes('#')) {
        return;
      }

      let element = this.getElementFromAnchor(href);
      if (element == null) {
        return;
      }

      element.scrollIntoView();
      
      // maybe needs to open a tab
      Drupal.behaviors.weaver_tailwind_tabs.anchorOpenTab(href);
      
      this.closeAllTakeovers();
    },

    getElementFromAnchor: function(anchor) {
      const elementId = anchor.split('#').pop();
      const element = document.getElementById(elementId);
      return element;
    },

    // toggles closed and open classes on buttons, used for styling
    toggleSidebutt: function(button, sideButtons) {
      let y = window.scrollY;
      let headerRect = document.getElementById('masthead').getBoundingClientRect();

      sideButtons.forEach(sideButton => {
        if (button.dataset.tweTarget != sideButton.dataset.tweTarget) {
          sideButton.dataset.ptbToggle = 'closed';
        }
      });

      if (button.dataset.ptbToggle == 'open') {
        button.dataset.ptbToggle = 'closed';
        if (y <= headerRect.height) {
          document.body.classList.remove('ptb-sidebutt-fixed');
        }
      } else {
        button.dataset.ptbToggle = 'open';
        document.body.classList.add('ptb-sidebutt-fixed');
      }
    },

    toggleTakeover: function(takeoverId) {
      const takeoverElement = document.getElementById(takeoverId);

      if (takeoverElement == null) {
        return;
      }

      const takeover = twe.Offcanvas.getOrCreateInstance(takeoverElement);

      takeover.toggle();
    },

    attach: function (context, settings) {

      $(once('weaver_tailwind_takeovers', 'body', context)).each(function () {

        const takeovers = Drupal.behaviors.weaver_tailwind_takeovers;

        takeovers.checkScroll();
        takeovers.initializeKeyboardShortcuts();
        takeovers.initializeLinkClicks();
        takeovers.initializeNavHashLinks();
        takeovers.initializeOffcanvasEvents();
        takeovers.initializeToggleSidebutt();
        takeovers.initializeTakeoverSearchForm();

        window.addEventListener('resize', () => {
          takeovers.checkScroll();
        });
      });
    }
  };
})(jQuery, Drupal, once);